import { Days } from './types'

export const DEFAULT_HUMAN_TIME = 'HH:mm'
export const DEFAULT_HUMAN_TIME_WITH_SECONDS = 'HH:mm:ss'
export const BERLIN_TIME_ZONE = 'Europe/Berlin'
export const FULL_DATE_TIME = "yyyy-MM-dd'T'HH:mm:ss"

export const DEFAULT_DAYS_SETTING: Days = { mo: false, tu: false, we: false, th: false, fr: false, sa: false, su: false }
